<template>
  <div id="app">
  <!-- MODAL AVISO GERANDO ARQUIVO-->
    
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-alert modal-dialog d-flex flex-column align-content-center" role="document" >
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                &nbsp;                                
                            </div>
                            
                            <div class="modal-body overflow-auto" style='color: #eee; font-weight: bold; height: 47px;
padding: 5px 0px;'>
                                <div class="loader loader-div"></div> 
                                <div class="txt-loader"> {{ $t("160") }}</div>
                            </div>

                            <div class="modal-footer">
                                &nbsp;
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
   
    <!-- FIM MODAL AVISO GERANDO ARQUIVO-->

  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'

export default {
  props: {
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>

body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

.table {
    border-radius: 0px; 
    width: 100%;
    margin: 0;
    height: 100%;
} 

th {
    background-color: #343a40;
    color: white;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 12px;
    white-space: nowrap;
}

td {
  /* min-width: 120px; */
    padding: 10px 10px;
    white-space: nowrap;
    width: 1%;
    background-color: #343a40;
    color: white;
}

td{
    font-size: 11px;
}

tr:nth-child(even) > td {
  background-color: #454d55;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.desc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}

#search-input{
    position: absolute;
    right: 65px;
    top: 5px;
}

.modal-mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
}

.modal-header{
    height: 54px;
    align-items: center;
    align-content: center;
    color: white;
}

.modal-body{
    margin: 0;
    padding: 0;
    overflow: auto;
    max-height: 80vh;
}

.modal-dialog{
    width: 90vw;
}

.modal-content{
    padding: 0;
    /* background: #1f1f20; */
    background: #2a2a2e;
    /* max-height: 80vh; */
}

.table{
    max-height: 90vh;
}

.col-01{
    width: 80%;
    float: left;
}
.col-02{
    width: 15%;
    float: left;
}
.col-03{
    width: 5%;
    float: left;
}
.csv-bt{
    outline: none;
    z-index: 10;
    float: right;
    background: #343a40;
    border-color: #343a40;
    color:
    white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -6px;
    height: 35px;
    border-radius: 5px;
}
.csv-bt:hover{
    background: #454d55;
}

#close-button{
    outline: none;
    z-index: 10;
    margin-right: 10;
}

.ti-close{
    color: white;
    border-color: white;
    text-shadow: white;
}

.modal-footer{
    height: 50px;
    justify-content: end;
    align-items: center;
    padding: 5px 15px;
    color: white;
}

.page-link{
    background: #343a40;
    border-color: #343a40;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    margin-top: -20px;
    height: 35px;
}
.page-link:hover{
    background: #454d55;
}

.modal-title{
    color: white;
    font-weight: 100;
    font-size: 22px;
    margin: -10px 1px;
}

.table td.fit, 
.table th.fit {
    white-space: nowrap;
    width: 1%;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

#spinner-loading{
    padding: 50px 0;
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #72b5e1; /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
  margin: 0 auto;
}
.loader-div{
    float: left;
    margin-left: 22%;
    margin-right: 5%;

}
.txt-loader{
    padding-top: 8px;
}
.modal-alert{
    width: 25% !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 770px) {
    .modal-dialog {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
    }
    .modal-alert{
        width: 100% !important;
    }
}

.table-input{
    width: 100%;
    height: 25px;
    font-size: 14px;
    padding: auto auto;
}

.table-header{
    margin: 0 auto;
    padding: 0;
    margin-bottom: -20px;   
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/Csv.vue